import { jsx } from "react/jsx-runtime";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import { validateTidalLicense } from "../../base/index.js";
function PauseCircleOutline(props) {
  return /* @__PURE__ */ jsx(
    PauseCircleOutlineIcon,
    {
      "data-testid": "PauseCircleOutline",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "PauseCircleOutline",
      "data-tidal-icon-meta": "cancel,informative"
    }
  );
}
PauseCircleOutline.tidalIconMeta = {
  categories: "cancel,informative",
  name: "PauseCircleOutline"
};
validateTidalLicense();
export {
  PauseCircleOutline
};
//# sourceMappingURL=PauseCircleOutline.js.map
